import { lazy, memo, Suspense } from "react";
import "maplibre-gl/dist/maplibre-gl.css";
import type { CommuteMapProps } from "./types";

const LazyCommuteMap = lazy(() =>
  import("./index").then((module) => ({ default: module.CommuteMap })),
);

export const CommuteMapShell = memo(function CommuteMapShell(
  props: CommuteMapProps,
) {
  return (
    <Suspense
      fallback={
        <div className="flex h-full min-h-[20rem] items-center justify-center rounded-[1.5rem] border border-border bg-card text-sm text-muted-foreground">
          Loading map...
        </div>
      }
    >
      <LazyCommuteMap {...props} />
    </Suspense>
  );
});
